import { z } from "zod";

const propertySchema = z.object({
	name: z.string().min(1, "Name is required"),
	purchase_date: z
		.string()
		.refine((date) => !isNaN(Date.parse(date)), {
			message: "Invalid date format",
		})
		.nullish(),
	completion_date: z
		.string()
		.refine((date) => !isNaN(Date.parse(date)), {
			message: "Invalid date format",
		})
		.nullish(),
	property_lien_type: z.string().nullish(),
	address: z.string().min(1, "Address is required"),
	company: z.string().uuid("Company is required"),
	entity: z.string().uuid().nullish(),
});

export const propertyCreateSchema = propertySchema;
export const propertyUpdateSchema = propertySchema.partial();
